import "./Shadows.css";

export default function Shadows() {
  return (
    <section className="ui-kit-section">
      <h2 className="ui-kit-title">Shadow</h2>

      <div className="ui-shadows">
        <ShadowItem label="Shadow 1" shadowVar="--shadow-1" />
        <ShadowItem label="Shadow 2" shadowVar="--shadow-2" />
        <ShadowItem label="Shadow 3" shadowVar="--shadow-3" />
      </div>
    </section>
  );
}

function ShadowItem({ label, shadowVar }) {
  return (
    <div className="ui-shadow-item">
      <div
        className="ui-shadow-item__card"
        style={{ "--preview-shadow": `var(${shadowVar})` }}
      />
      <div className="ui-shadow-item__label">
        <span>{label}</span>
        <span className="ui-shadow-item__token">{shadowVar}</span>
      </div>
    </div>
  );
}
